export default "__VITE_ASSET__Co58wHfQ__"